<section class="bncs-assessment">
  <div class="bncs-assessment__header">
    <h2 class="bncs-assessment__title">B&CS Assessment</h2>
    <p class="bncs-assessment__subtitle">
      A centralized hub for B&CS assessments aligned to Legal Entity workflows
    </p>
  </div>

  <div class="bncs-assessment__content">
    <div class="bncs-assessment__field">
      <span class="bncs-assessment__label">B&CS Required File:</span>
      @if (bncsDocuments.length > 0) {
        <div class="bncs-assessment__documents-list">
          @for (doc of bncsDocuments; track doc) {
            <a class="bncs-assessment__document-link" (click)="downloadDocument(doc)">
              <span class="bncs-assessment__document-text">{{ doc.name }}</span>
              <span class="material-symbols-outlined bncs-assessment__document-icon">draft</span>
            </a>
          }
        </div>
      }
      @if (userPermissions.hasUploadBncsDocumentPermission()) {
        <app-az-button [label]="'Upload'" [icon]="'upload'" (click)="openModal()"></app-az-button>
      }
    </div>

    <div class="bncs-assessment__field">
      <span class="bncs-assessment__label">Document Date:</span>
      <div class="bncs-assessment__date-text">{{ documentDate || '--' }}</div>
    </div>
  </div>
</section>

<app-az-document-update-modal
  [isOpen]="isModalOpen"
  [documentTypes]="filteredDocumentTypes"
  [allowedFileTypes]="allowedFileTypes"
  [isUploading]="isUploading"
  [preselectedDocumentType]="preselectedDocumentType"
  [disableDocumentTypeSelector]="shouldDisableDocumentTypeSelector"
  (closed)="closeModal()"
  (upload)="handleUpload($event)"
></app-az-document-update-modal>

<app-status-change-modal
  [isOpen]="isStatusModalOpen"
  [title]="statusModalTitle"
  [initialState]="'success-with-message'"
  (closed)="closeStatusModal()"
></app-status-change-modal>
